import { observer } from 'mobx-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslations } from 'next-intl';
import wooCommerceStore from '@/stores/woocommerceStore';

const QuantityError = observer(() => {
  const { quantityError } = wooCommerceStore;
  const t = useTranslations('Cart');

  if (!quantityError) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className="fixed bottom-4 right-4 bg-red-50 text-red-600 rounded-lg shadow-lg p-4 max-w-sm z-50 border border-red-100"
      >
        {typeof quantityError === 'string' ? quantityError : t(quantityError.key, quantityError.values)}
      </motion.div>
    </AnimatePresence>
  );
});

export default QuantityError;